import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { disciplineStyles } from "../../Assets/js/customStyles.js";


export default function Internalmarkmapping() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const tableRef = useRef(null);

  const [disciplineId, setDisciplineChange] = useState(sessionStorage.getItem("discipline_id") ? sessionStorage.getItem("discipline_id") : null);
  const [disciplinetype, setDisciplineTypeChange] = useState(sessionStorage.getItem("discipline_type") ? sessionStorage.getItem("discipline_type") : null);
  const [examid, setExamIdData] = useState(sessionStorage.getItem("eaxm_id") ? sessionStorage.getItem("eaxm_id") : null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);

  const [loading, setlodaing] = useState(false);

  const [getexamData, setExamData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showrevertModal, setShowRevertModal] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null); // Track the selected course

  const { http } = Api();
  let cid = localStorage.getItem("collegeid");

  const handlExamChange = (selectedOption) => {
    // Clear the discipline data and table data when exam changes
    setDisciplineData([]);

    setExamIdData(selectedOption.value);
    fetchDisciplineData(selectedOption.value); // Trigger the API call
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`College/getInternalExams`);
        // console.log("response", response.data);
        setExamData(response.data);
      }
      catch (error) {
        if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

  // Function to fetch discipline data based on selected exam ID
  const fetchDisciplineData = async (selectedExamId) => {
    try {
      const response = await http.get(`College/getCollegeOptedDisciplines_CO_Mapping`, {
        params: {
          examid: selectedExamId
        },
      });

      if (response.data.status_code === 'ERR5') {
        setflag(true);
      }
      setDisciplineData(response.data);
    } catch (error) {
      if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  // Calculate the maximum number of COs across all courses
  const maxCOs = Math.max(...courseData.map(course => course.maxMarks.no_of_co));

  const handlDisciplineChange = async (selectedOption) => {
    setCourseData([]); // Clear the course data initially

    setDisciplineChange(selectedOption.did);
    setDisciplineTypeChange(selectedOption.type); // Update the discipline type
    try {
      const response = await http.get(`College/getCollegeCoursesForInternal`, {
        params: {
          discipline_id: selectedOption.did,
          college_course_type: selectedOption.type,
          examid: examid
        },
      });

      if (response.data.status_code === 'ERR5') {
        setflag(true);
      }

      // Set course data with API response
      setCourseData(response.data); // Assuming response.data is structured as expected
    } catch (error) {
      if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
      }
    }
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  const handleApprovalClick = async (course) => {
    if (!course || loadingCourses.includes(course.courseId)) return; // Prevent multiple clicks

    setLoadingCourses((prev) => [...prev, course.courseId]);
    try {
      const params = {
        discipline_id: disciplineId,
        college_course_type: disciplinetype,
        examid: examid,
        course_group_id: course.courseGroupId,
        courseid: course.courseId,
      };

      const response = await http.post(`College/CO_MappingApproval`, params);

      if (response.data.http_status === 200 && response.data.status_code == "MSG2") {
        toast.success(response.data.message);
        // Reload updated data
        await fetchDisciplineData(examid); // Reload discipline data
        if (disciplineId && disciplinetype) {
          await handlDisciplineChange({
            did: disciplineId,
            type: disciplinetype,
          }); // Reload course data for the selected discipline
        }
      } else {
        toast.error(response.data.message || "Approval Failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Something went wrong during approval"
      );
    } finally {
      setLoadingCourses((prev) =>
        prev.filter((id) => id !== course.courseId)
      );
    }
  };

  const handleOpenModal = (course) => {
    setSelectedCourse(course); // Set the course for approval
    setShowModal(true); // Open the modal
  };

  const handleConfirmApproval = () => {
    if (selectedCourse) {
      handleApprovalClick(selectedCourse); // Call approval function
      setShowModal(false); // Close the modal
      setSelectedCourse(null); // Reset selected course
    }
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
    setSelectedCourse(null); // Reset selected course
  };


  const handleRejectClick = async (course) => {
    if (!course || loadingCourses.includes(course.courseId)) return; // Prevent multiple clicks

    setLoadingCourses((prev) => [...prev, course.courseId]);
    try {
      const params = {
        discipline_id: disciplineId,
        college_course_type: disciplinetype,
        examid: examid,
        course_group_id: course.courseGroupId,
        courseid: course.courseId,
      };

      const response = await http.post(`College/CO_MappingRevert`, params);

      if (response.data.http_status === 200) {
        toast.success(response.data.message);
        // Reload updated data
        await fetchDisciplineData(examid); // Reload discipline data
        if (disciplineId && disciplinetype) {
          await handlDisciplineChange({
            did: disciplineId,
            type: disciplinetype,
          }); // Reload course data for the selected discipline
        }
      } else {
        toast.error(response.data.message || "Revert Failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Something went wrong during approval"
      );
    } finally {
      setLoadingCourses((prev) =>
        prev.filter((id) => id !== course.courseId)
      );
    }
  };



  const handleOpenRevertModal = (course) => {
    setSelectedCourse(course); // Set the course for approval
    setShowRevertModal(true); // Open the modal
  };

  const handleConfirmRevert = () => {
    if (selectedCourse) {
      handleRejectClick(selectedCourse); // Call approval function
      setShowRevertModal(false); // Close the modal
      setSelectedCourse(null); // Reset selected course
    }
  };

  const handleCloseRevertModal = () => {
    setShowRevertModal(false); // Close the modal
    setSelectedCourse(null); // Reset selected course
  };


  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (


          <div className="container-fluid" >
            <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="modal-toggle-wrapper">
                      <h4 className="text-center pb-2">Are you sure you want to Approve?</h4>
                      <div className="d-flex justify-content-center mt-3">
                        <button className="btn btn-success mx-2" onClick={handleConfirmApproval}>Yes</button>
                        <button
                          className="btn"
                          style={{
                            backgroundColor: 'white',
                            borderColor: 'green',
                            color: 'black',
                          }}
                          onClick={handleCloseModal}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={`modal fade show ${showrevertModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="modal-toggle-wrapper">
                      <h4 className="text-center pb-2">Are you sure you want to revert?</h4>
                      <div className="d-flex justify-content-center mt-3">
                        <button className="btn btn-danger mx-2" onClick={handleConfirmRevert}>Yes</button>
                        <button
                          className="btn"
                          style={{
                            backgroundColor: 'white',
                            borderColor: 'red',
                            color: 'black',
                          }}
                          onClick={handleCloseRevertModal}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h5>Course Outcome Mapping Verification</h5>
                      </div>

                    </div>
                    <div className="card-body">

                      <div className="card-body pdg">
                        <div className="table-responsive">

                          <div className="form theme-form">
                            <div className="card-body custom-input">


                              <div className="row">
                                <div className="col-md-6">
                                  <label>Examination <span className="errorclr">*</span></label>

                                  <Select
                                    styles={customStyles}
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="exam_id"
                                    name="exam_id"
                                    className="basic-select"
                                    classNamePrefix="select"
                                    options={getexamData.map(exam => ({
                                      value: exam.examid,
                                      label: exam.examtitle
                                    }))}
                                    onChange={handlExamChange}
                                    placeholder="Select an exam..."

                                    value={getexamData
                                      .filter(exam => exam.examid.toString() === examid ? examid.toString() : '')
                                      .map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle
                                      }))[0]}
                                  />
                                </div>


                                <div className="col-md-6">
                                  <label>Discipline<span className="errorclr">*</span></label>

                                  <Select
                                    styles={disciplineStyles}

                                    maxMenuHeight={500}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    onChange={handlDisciplineChange}
                                    options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                      ? disciplinedata
                                        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                        .map(discipline => ({
                                          did: discipline.id,
                                          value: discipline.discipline_name,
                                          label: discipline.discipline_name,
                                          type: discipline.college_course_type
                                        }))
                                      : [{ value: '0', label: 'No data found' }]
                                    }
                                    value={disciplinedata && Array.isArray(disciplinedata)
                                      ? disciplinedata
                                        .filter(discipline =>
                                          discipline.id.toString() === disciplineId &&
                                          discipline.college_course_type === disciplinetype // Added filter for discipline_type
                                        )
                                        .map(discipline => ({
                                          value: discipline.discipline_name,
                                          label: discipline.discipline_name,
                                        }))[0]
                                      : null}

                                    placeholder="Select Discipline"
                                  />

                                </div>


                              </div>







                              <div className="table-container mt-5" style={{ minHeight: '500px' }}>
                                <table className="display dataTable table table-light table-bordered" >
                                  <tbody>
                                    {courseData.length > 0 ? (
                                      courseData.map((course, courseIndex) => (
                                        <React.Fragment key={courseIndex}>
                                          {/* Header Row */}
                                          <tr>

                                            <th colSpan={maxCOs + 2} className="bg-primary bg-gradient">
                                              <span class="badge rounded-pill badge-warning" style={{ color: 'black' }}>{course.groupName}</span>  {course.courseCode} - {course.courseName}  - {course.collegeCourseType} &nbsp;&nbsp;

                                              {course.maxMarks.theory && course.maxMarks.theory > 0 && (
                                                <span>
                                                  Theory (Max. Mark): {course.maxMarks.theory}
                                                </span>
                                              )}&nbsp;&nbsp;
                                              {course.maxMarks.practical && course.maxMarks.practical>0 && (
                                                <span>
                                                  Practical (Max. Mark): {course.maxMarks.practical}
                                                </span>
                                              )}&nbsp;&nbsp;
                                            </th>
                                            {/* Add an Action Header for the Icons */}
                                            <th className="bg-primary" style={{ textAlign: "center" }}>
                                              Status
                                            </th>
                                          </tr>

                                          {/* CO Headers */}
                                          <tr>
                                            <td></td>
                                            {Array.from({ length: maxCOs }).map((_, coIndex) => (
                                              <td key={coIndex}>
                                                <b>{coIndex < course.maxMarks.no_of_co ? `CO${coIndex + 1}` : " "}</b>
                                              </td>
                                            ))}
                                            {/* Add an empty cell for the "Action" column */}

                                            <td style={{ textAlign: "center" }}>
                                              {course.verificationStatus === 'deo_forwarded' && (
                                                <>
                                                  <b>Action</b>
                                                </>
                                              )}
                                            </td>
                                            <td rowSpan={3} style={{ textAlign: "center", verticalAlign: "middle" }}>
                                              <span style={{ marginLeft: "5px" }}>
                                                {course.verificationStatus === "principal_forwarded" && (
                                                  <i className="fas fa-check-circle" style={{ color: "green" }} title="Principal Forwarded"></i>
                                                )}
                                                {course.verificationStatus === "deo_forwarded" && (
                                                  <i className="fa fa-exclamation-circle" style={{ color: "orange" }} title="DEO Forwarded"></i>
                                                )}
                                                {course.verificationStatus == null && (
                                                  <i className="fa fa-hourglass-half" style={{ color: "red" }} title="CO Mapping not done"></i>
                                                )}
                                                {course.verificationStatus == "principal_reverted" && (
                                                  <i className="fa fa-exclamation-circle" style={{ color: "RoyalBlue" }} title="CO Mapping not done"></i>
                                                )}
                                              </span><br />


                                              {/* Display verificationStatus */}
                                              <span
                                                style={{
                                                  fontSize: "0.9rem",
                                                  textAlign: 'center',
                                                  color:
                                                    course.verificationStatus === "principal_forwarded"
                                                      ? "green"
                                                      : course.verificationStatus === "deo_forwarded"
                                                        ? "orange"
                                                        : course.verificationStatus === "principal_reverted"
                                                          ? "RoyalBlue"
                                                          : "red", // Adjust colors for statuses
                                                }}
                                              >
                                                {course.displayStatus == null ? "--" : course.displayStatus}
                                              </span>
                                            </td>
                                          </tr>

                                          {/* Theory Row */}
                                          <tr>
                                            <td>
                                            {course.maxMarks.theory &&  course.maxMarks.theory>0 && (
                                              <b>Theory</b>
                                            )}
                                            </td>
                                            {Array.from({ length: maxCOs }).map((_, coIndex) => (
                                              <td key={coIndex}>
                                                {coIndex < course.maxMarks.no_of_co && course.maxMarks.theory>0
                                                  ? (course.coValues.length > 0 && course.coValues[coIndex]?.theory !== undefined
                                                    ? course.coValues[coIndex].theory
                                                    : "--") // If coValues is empty or undefined, display '--'
                                                  : ""}
                                              </td>
                                            ))}
                                            {/* Action Icons in the last column */}

                                            <td style={{ textAlign: "center" }} rowSpan={2}>
                                              {course.verificationStatus === 'deo_forwarded' && (
                                                <>

                                                  <button className='btn btn-success btn-sm' style={{ padding: '6px' }} onClick={() => handleOpenModal(course)}> <i
                                                    className="fa fa-check-circle"
                                                    style={{ color: "white" }}
                                                    aria-hidden="true"
                                                  // Open modal on click
                                                  ></i>&nbsp; Approve</button>&nbsp;&nbsp;
                                                  <button className='btn btn-danger btn-sm' style={{ padding: '6px' }} onClick={() => handleOpenRevertModal(course)}>
                                                    <i
                                                      className="fa fa-undo"
                                                      style={{
                                                        color: "white"
                                                      }}
                                                      aria-hidden="true"

                                                    ></i>&nbsp; Revert</button></>
                                              )}

                                            </td>
                                          </tr>

                                          {/* Practical Row */}
                                          
                                          <tr>
                                            <td>
                                            {course.maxMarks.practical && course.maxMarks.practical>0 && (
                                              <b>Practical</b>
                                            )}
                                           
                                            </td>
                                            {Array.from({ length: maxCOs }).map((_, coIndex) => (
                                              <td key={coIndex}>
                                                {coIndex < course.maxMarks.no_of_co && course.maxMarks.practical>0 
                                                  ? (course.coValues.length > 0 && course.coValues[coIndex]?.practical !== undefined
                                                    ? course.coValues[coIndex].practical
                                                    : "--") // If coValues is empty or undefined, display '--'
                                                  : " "}
                                              </td>
                                            ))}
                                          </tr>
                                        </React.Fragment>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan={maxCOs + 3} style={{ textAlign: "center" }}>
                                          No Data Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>

                              </div>







                            </div>


                          </div>



                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        )}


      </Template>
    </>
  );
}
